import { render } from "./CreateNotice.vue?vue&type=template&id=78e114e0&scoped=true"
import script from "./CreateNotice.vue?vue&type=script&lang=js"
export * from "./CreateNotice.vue?vue&type=script&lang=js"

import "./CreateNotice.vue?vue&type=style&index=0&id=78e114e0&scoped=true&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e114e0"]])

export default __exports__